@switch (type()) {
  @case ('regular') {
    @if (html()) {
      <span
        class="text"
        (mouseenter)="updateShowTooltip()"
        [pTooltip]="showTooltip() ? text() || html() : ''"
        [tooltipPosition]="tooltipPosition() || 'top'"
        tooltipStyleClass="u-tooltip"
        #textElement
        [escape]="false"
        [innerHtml]="html() | safe: 'html'"
      >
      </span>
    } @else {
      <span
        class="text"
        (mouseenter)="updateShowTooltip()"
        [pTooltip]="showTooltip() ? text() : ''"
        [tooltipPosition]="tooltipPosition() || 'top'"
        tooltipStyleClass="u-tooltip"
        [class.lines]="lines()"
        [style.-webkit-line-clamp]="lines()"
        #textElement
      >
        {{ text() }}
      </span>
    }
  }
  @case ('file') {
    <span
      class="text-file"
      (mouseenter)="updateShowTooltip()"
      [pTooltip]="showTooltip()? text() || html() : ''"
      [tooltipPosition]="tooltipPosition() || 'top'"
      tooltipStyleClass="u-tooltip"
      [escape]="false"
    >
      <span class="text" #textElement> {{ startText() }} </span>
      <span class="end-of-text">{{ endText() }}</span>
    </span>
  }
}
